import { Reporter } from '../reporter/Reporter'

type props = { text?: string }

export const BakingSheet: React.FC<props> = ({ text }) => (
  <div className={'affiliate'}>
    <Reporter
      text={text}
      defaultText={'Baking sheet'}
      link="https://www.amazon.com/TeamFar-Stainless-Cooling-Healthy-Dishwasher/dp/B07DXF7CVL" // https://amzn.to/39kQ4L4
    />
  </div>
)

export const FoodProcessor: React.FC<props> = ({ text }) => (
  <div className={'affiliate'}>
    <Reporter
      text={text}
      defaultText={'Food processor'}
      link="https://www.amazon.com/Hamilton-Beach-70730-Processor-Vegetable/dp/B008J8MJIQ" // https://amzn.to/3s9c9oG
    />
  </div>
)

export const InstantPot: React.FC<props> = ({ text }) => (
  <div className={'affiliate'}>
    <Reporter
      text={text}
      defaultText={'Instant Pot'}
      link="https://www.amazon.com/Instant-Pot-Programmable-Pressure-Steamer/dp/B01B1VC13K" // https://amzn.to/2LESlZi
    />
  </div>
)

export const MeatThermometer: React.FC<props> = ({ text }) => (
  <div className={'affiliate'}>
    <Reporter
      text={text}
      defaultText={'Meat thermometer'}
      link="https://www.amazon.com/Saferell-Thermometer-Backlight-Calibration-Foldable/dp/B087GLK8GB" // https://amzn.to/38yNd2h
    />
  </div>
)

export const SautePan: React.FC<props> = ({ text }) => (
  <div className={'affiliate'}>
    <Reporter
      text={text}
      defaultText={'Saute pan'}
      link="https://www.amazon.com/Tramontina-80116-058DS-Induction-Ready-NSF-Certified/dp/B01M8LRH62" // https://amzn.to/3blxEww
    />
  </div>
)

export const SiliconeTongs: React.FC<props> = ({ text }) => (
  <div className={'affiliate'}>
    <Reporter
      text={text}
      defaultText={'Silicone tongs'}
      link="https://www.amazon.com/Kitchen-Silicone-Non-Stick-Stainless-Grilling/dp/B074WB5D79" // https://amzn.to/3hX9slr
    />
  </div>
)
